import { Children, ReactNode } from 'react';

import { Carousel } from '@mantine/carousel';
import { useMatches } from '@mantine/core';

import cx from './TeaserCarousel.module.scss';

const TeaserCarousel = ({ children }: { children: ReactNode }) => {
    const items = Children.toArray(children);
    const itemsPerRow = useMatches({ base: 2, sm: 4, md: 5, lg: 7 });

    if (items.length <= itemsPerRow) {
        return (
            <div className={cx.row}>
                {items.map((item, index) => (
                    <div key={index} className={cx.rowItem}>
                        {item}
                    </div>
                ))}
            </div>
        );
    }

    return (
        <Carousel
            classNames={{ root: cx.carousel, viewport: cx.viewport, controls: cx.controls }}
            slideSize={{ base: '42%', sm: '23%', md: '18.5%', lg: '13.5%' }}
            slideGap="md"
            emblaOptions={{ align: 'start', containScroll: 'trimSnaps' }}
        >
            {items.map((item, index) => (
                <Carousel.Slide key={index}>{item}</Carousel.Slide>
            ))}
        </Carousel>
    );
};

export { TeaserCarousel };
